
import { yupResolver } from "@hookform/resolvers/yup";
import Button from "../components/button";
import FormHead from "../components/headings/FromHead";
import Styles from "./styles.module.scss";
import { FormInput } from "../wrappers/formInput";
import * as Yup from 'yup';
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";


export type PublicationsModalFormFields = {
  title: string;
  year: number;
  link: string;
  action: string; 
  
};

interface Props {
  ClickHandler :any;
  onClose:any;
  defaultValues:any;
}

const validationSchema = Yup.object({
    title: Yup.string()
    .required("Field is required"),
    year: Yup.string()
    .required("Field is required")
    .max(4, 'Invalid year'),
    link: Yup.string()
    .transform((currentValue, originalValue) => {
      return originalValue === '' ? null : currentValue;})
    .nullable(true)
    .matches(/((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/,'Please provide a valid link'),
})
const Publication: React.FC<Props> = ({
  ClickHandler,
  onClose,
  defaultValues
}) => { 


  const formOptions = {
    resolver:yupResolver(validationSchema)
  }

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<PublicationsModalFormFields>(formOptions);

  useEffect(() => {
    if(defaultValues){
      reset(defaultValues);
      setValue('action', 'update')
    }else {
      setValue('action', 'add')
    } 
  }, [defaultValues, defaultValues.education, reset, setValue])

  const[absYear, setAbsYear] = useState<string>('')

    const onclose = () => {
      onClose()
    }
    
    const onSubmit = (data:any) => {
      data.action= defaultValues ? 'update' : 'add'
      ClickHandler(data)
    }

    const handleChange = (e:any,name:string) => {
      setAbsYear(e.target.value ? Math.abs(e.target.value).toString() : '')
    }
 
    return(
      
      <div className={Styles.detailsCard}>
        <FormHead>Publications</FormHead>
          <form>
            <div className="form-group">
                <FormInput<PublicationsModalFormFields>
                  id="title"
                  type="text"
                  name="title"
                  label="Title*"
                  placeholder=""
                  register={register}
                  errors={errors}
                />
            </div>
            <div className="form-group">
                <FormInput<PublicationsModalFormFields>
                  id="year"
                  type="number"
                  name="year"
                  label="Year*"
                  placeholder=""
                  value={absYear}
                  register={register}
                  errors={errors}
                  onchange={(e:any) => handleChange(e,'year')}
                />
            </div>
            <div className="form-group">
                <FormInput<PublicationsModalFormFields>
                  id="Link"
                  type="text"
                  name="link"
                  label="Link"
                  placeholder=""
                  register={register}
                  errors={errors}
                />
            </div>
            <div className={Styles.popupAction}>
              <Button onClick={onclose} type="submit" variant="secondary" size="small">Cancel</Button>
              <Button onClick={handleSubmit(onSubmit)} type="submit" variant="primary" size="small">Save</Button>
            </div>
            </form>
          </div>
         
    )
}

export default Publication;